// StatCard.jsx
import React from 'react';
import { Card } from 'react-bootstrap';

const StatCard = ({ title, value, subtitle, icon, color, filterType, isActive, onClick }) => {
    const hexToRgba = (hex, alpha) => {
        const r = parseInt(hex.slice(1, 3), 16);
        const g = parseInt(hex.slice(3, 5), 16);
        const b = parseInt(hex.slice(5, 7), 16);
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    };

    return (
        <Card
            className={`border-0 shadow-sm h-100 ${isActive ? 'active-stat-card' : ''}`}
            style={{
                cursor: 'pointer',
                border: isActive ? `2px solid ${color}` : '1px solid #e5e7eb',
                backgroundColor: isActive ? hexToRgba(color, 0.08) : '#ffffff',
                transform: isActive ? 'translateY(-2px)' : 'none',
                boxShadow: isActive ? `0 4px 12px ${hexToRgba(color, 0.15)}` : '0 1px 3px rgba(0,0,0,0.1)',
                transition: 'all 0.3s ease'
            }}
            onClick={onClick}
        >
            <Card.Body className="p-3">
                <div className="d-flex align-items-center">
                    <div
                        className="rounded-circle d-flex align-items-center justify-content-center me-3"
                        style={{
                            width: "48px",
                            height: "48px",
                            backgroundColor: isActive ? color : `${color}15`,
                            color: isActive ? '#fff' : color,
                            transition: 'all 0.3s ease'
                        }}
                    >
                        {React.cloneElement(icon, {
                            size: 20,
                            color: isActive ? '#fff' : color
                        })}
                    </div>
                    <div>
                        <h6 className="mb-1" style={{
                            fontSize: "0.875rem",
                            color: isActive ? color : '#6b7280',
                            fontWeight: isActive ? '600' : '400'
                        }}>
                            {title}
                        </h6>
                        <h4 className="fw-bold mb-0" style={{
                            color: isActive ? color : '#1f2937',
                            fontSize: "1.5rem"
                        }}>
                            {value}
                        </h4>
                        {subtitle && (
                            <small style={{
                                fontSize: "0.75rem",
                                color: isActive ? color : '#6b7280'
                            }}>
                                {subtitle}
                            </small>
                        )}
                    </div>
                </div>
            </Card.Body>
        </Card>
    );
};

export default StatCard;